import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Alert from "react-bootstrap/Alert";
import Nav from "react-bootstrap/Nav";
import { useEffect, useState } from "react";
import { getPracticeById, updatePractice, getDisciplineCodes } from "../../api";
import { getPlacesOfService } from "../../afinanceapi";
import { useNavigate } from "react-router-dom";
import { FaCheck, FaTimes } from "react-icons/fa";
import React from "react";

export function EditPractice(props) {
  const { practiceNum, onHide, show, onPracticeUpdate } = props;
  const [errors, setErrors] = useState({});
  const [successAlert, setSuccessAlert] = useState(false);
  const [holding, setHolding] = useState();
  const [closeAlert, setCloseAlert] = useState(false);
  const navigate = useNavigate();
  const [displines, setDisplines] = useState([]);
  const [availableDisciplines, setAvailableDisciplines] = useState([]);
  const [practice, setPractice] = useState({
  practiceName: "",
  pracitceType: "",
  practiceNumber: "",
  vatNumber: "",
  practiceEmail: "",
  practicePhoneNumber: "",
  practiceAddress: "",
  practiceAddress2: "",
  practiceCity: "",
  practiceProvince: "",
  practicePostalCode: "",
  practiceWebsite: "",
  holdingPractice: "",
  practiceMedicalType: "",
  practiceDisciplineCode: "",
  practiceDisciplineName: "",
  hpcsaNumber: "",
  primaryLocationName: "Main Location",
  practicePlaceOfService: "",
  locations: [],
});
const [newLoc, setNewLoc] = useState({
  name: "",
  address1: "",
  address2: "",
  city: "",
  province: "",
  postalCode: "",
  placeOfService: "",
});
// NEW: track which location is being edited (null = none)
const [editIndex, setEditIndex] = useState(null);   // number | null
const [draftLoc, setDraftLoc] = useState(null);     // location draft while editing
const [locTab, setLocTab] = useState("locations");
const [numberingMethod, setNumberingMethod] = useState("sequential");
const [numberingPrefix, setNumberingPrefix] = useState("");
const [eraAutoAllocate, setEraAutoAllocate] = useState(true);
const [eraEnabled, setEraEnabled] = useState(true);
const [placesOfService, setPlacesOfService] = useState([]);

useEffect(() => {
  let cancelled = false;
  getPlacesOfService()
    .then((data) => {
      if (cancelled) return;
      setPlacesOfService(Array.isArray(data) ? data : []);
    })
    .catch(() => { if (!cancelled) setPlacesOfService([]); });
  return () => { cancelled = true; };
}, []);


//Helpers

const handlePrimaryNameChange = (e) => {
  const name = e.target.value;
  setPractice((prev) => ({ ...prev, primaryLocationName: name }));
};

const addLocation = () => {
  const { name, address1, city, province, postalCode } = newLoc;
  if (!name || !address1 || !city || !province || !postalCode) {
    alert("Please fill name, address, city, province and postal code.");
    return;
  }
  setPractice((prev) => ({
    ...prev,
    locations: [...(prev.locations || []), { ...newLoc }],
  }));
  setNewLoc({ name: "", address1: "", address2: "", city: "", province: "", postalCode: "" });
};

const updateLocationField = (idx, field, value) => {
  setPractice((prev) => {
    const next = [...(prev.locations || [])];
    next[idx] = { ...next[idx], [field]: value };
    return { ...prev, locations: next };
  });
};

const removeLocation = (idx) => {
  setPractice((prev) => ({
    ...prev,
    locations: (prev.locations || []).filter((_, i) => i !== idx),
  }));
};



  useEffect(() => {
    async function loadPractice() {
      try {
        if (!practiceNum) {
          console.error("No practice number provided.");
          return;
        }
        // Fetch practice data
        const practiceData = await getPracticeById(practiceNum);

// derive locations if missing
const hasLocations = Array.isArray(practiceData.locations) && practiceData.locations.length > 0;
const primaryPos =
  practiceData.practicePlaceOfService ||
  practiceData.locations?.[0]?.placeOfService ||
  "";
const normalized = {
  ...practiceData,
  primaryLocationName: practiceData.primaryLocationName || "Main Location",
  practicePlaceOfService: primaryPos,
  locations: (Array.isArray(practiceData.locations) && practiceData.locations.length > 0)
    ? [
        // force index 0 to mirror legacy address fields
        {
          name: practiceData.primaryLocationName || "Main Location",
          address1: practiceData.practiceAddress || "",
          address2: practiceData.practiceAddress2 || "",
          city: practiceData.practiceCity || "",
          province: practiceData.practiceProvince || "",
          postalCode: practiceData.practicePostalCode || "",
          placeOfService: primaryPos,
        },
        ...practiceData.locations.slice(1),
      ]
    : [{
        name: practiceData.primaryLocationName || "Main Location",
        address1: practiceData.practiceAddress || "",
        address2: practiceData.practiceAddress2 || "",
        city: practiceData.practiceCity || "",
        province: practiceData.practiceProvince || "",
        postalCode: practiceData.practicePostalCode || "",
        placeOfService: primaryPos,
      }],
};
setPractice(normalized);
setNumberingMethod(practiceData.numberingConfig?.method || "sequential");
setNumberingPrefix(practiceData.numberingConfig?.prefix || "");
setEraAutoAllocate(practiceData.eraConfig?.autoAllocate !== false);
setEraEnabled(practiceData.eraConfig?.enabled !== false);

// Keep legacy fields as-is so your UI still shows them,
// but use `locations` for multi-location editing/saving.

        console.log("Practice data loaded:", practiceData);
        if (practiceData.holdingPractice === "true") {
          setHolding("true");
        } else {
          setHolding("false");
        }
      } catch (e) {
        console.error("Failed to load practice:", e);
      }
    }
    loadPractice();
  }, [practiceNum]);

  useEffect(() => {
    const fetchDisciplineCodes = async () => {
      try {
        const response = await getDisciplineCodes();
        setDisplines(response);
      } catch (error) {
        console.error("Error fetching discipline codes:", error);
      }
    };

    if (props.show) {
      fetchDisciplineCodes();
    }
  }, [props.show]);

  useEffect(() => {
    if (!practice.practiceMedicalType || displines.length === 0) return;
    const selectedType = practice.practiceMedicalType;
    const match = displines.find((d) => d.medicalType === selectedType);
    setAvailableDisciplines(match?.disciplines || []);
  }, [practice.practiceMedicalType, displines]);

  const validateForm = () => {
    const newErrors = {};

    // Required fields
    if (!practice.practiceName)
      newErrors.practiceName = "Practice name is required.";
    if (!practice.practiceNumber)
      newErrors.practiceNumber = "Practice number is required.";
    if (!practice.practiceMedicalType)
      newErrors.practiceMedicalType = "Practice care is required.";
    if (!practice.practiceEmail) newErrors.practiceEmail = "Email is required.";
    if (!practice.practicePhoneNumber)
      newErrors.practicePhoneNumber = "Phone number is required.";
    if (!practice.practiceAddress)
      newErrors.practiceAddress = "Address is required.";
    if (!practice.practiceCity) newErrors.practiceCity = "City is required.";
    if (!practice.practiceProvince)
      newErrors.practiceProvince = "Province is required.";
    if (!practice.practicePostalCode)
      newErrors.practicePostalCode = "Postal code is required.";

    // Field-specific validations
    if (practice.practiceNumber && practice.practiceNumber.length > 13)
      newErrors.practiceNumber = "Practice number cannot exceed 13 characters.";

    if (practice.vatNumber && !/^[4]\d{9}$/.test(practice.vatNumber))
      newErrors.vatNumber = "VAT number must be 10 digits and start with 4.";

    if (
      practice.practiceWebsite &&
      !/^www\..+\..+$/.test(practice.practiceWebsite)
    )
      newErrors.practiceWebsite = "Website must start with 'www'.";

    if (
      practice.practicePhoneNumber &&
      !/^\d{3}-\d{3}-\d{4}$/.test(practice.practicePhoneNumber)
    ) {
      newErrors.practicePhoneNumber =
        "Phone number must be in the format xxx-xxx-xxxx and 10 digits long.";
    }
    if (
      practice.practiceMedicalType !== "NM" &&
      practice.practiceMedicalType !== ""
    ) {
      if (!practice.practiceDisciplineCode) {
        newErrors.practiceDisciplineCode = "Practice Discipline is required.";
      }
      if (!practice.hpcsaNumber) {
        newErrors.hpcsaNumber = "Practice Owner HPCSA Number is required.";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  async function handleSubmit(e) {
  e.preventDefault();
  if (!validateForm()) return;

  try {
    // Ensure we always keep a "primary" location first in the array.
    // If there are no locations, derive one from legacy fields.
    const primaryFromLegacy = {
      name: practice.primaryLocationName || "Main Location",
      address1: practice.practiceAddress || "",
      address2: practice.practiceAddress2 || "",
      city: practice.practiceCity || "",
      province: practice.practiceProvince || "",
      postalCode: practice.practicePostalCode || "",
      placeOfService: practice.practicePlaceOfService || "",
    };

    // The primary's POS lives in practice.practicePlaceOfService: mirror it
    // into locations[0].placeOfService so downstream consumers (invoicing,
    // appointments) can read the POS off any selected location uniformly.
    let locations = (practice.locations && practice.locations.length > 0)
      ? [...practice.locations]
      : [primaryFromLegacy];
    if (locations.length > 0) {
      locations[0] = {
        ...locations[0],
        placeOfService: practice.practicePlaceOfService || locations[0].placeOfService || "",
      };
    }

    const payload = {
      ...practice,
      primaryLocationName: practice.primaryLocationName || "Main Location",
      locations, // <- source of truth
      numberingConfig: {
        method: numberingMethod,
        prefix: numberingMethod === "surname" ? numberingPrefix.trim() : "",
      },
      eraConfig: {
        enabled: eraEnabled,
        autoAllocate: eraAutoAllocate,
      },
    };

    const response = await updatePractice(practice._id, payload);
    if (response.status === 200) {
      setSuccessAlert(true);
      setTimeout(() => {
        setSuccessAlert(false);
        onHide?.();
        onPracticeUpdate?.();
      }, 1000);
    } else {
      alert(`${response.status} Practice not updated`);
    }
  } catch (err) {
    console.error(err);
    alert("Failed to update practice.");
  }
}


  function handleChange(e) {
  const { name, value } = e.target;

  if (name === "practicePhoneNumber") {
    const digits = value.replace(/\D/g, "");
    const formatted = digits.slice(0, 10).replace(/(\d{3})(\d{3})(\d{1,4})/, "$1-$2-$3");
    setPractice(prev => {
      const next = { ...prev, [name]: formatted };
      // keep locations[0] in sync
      const first = {
        name: next.primaryLocationName || "Main Location",
        address1: next.practiceAddress || "",
        address2: next.practiceAddress2 || "",
        city: next.practiceCity || "",
        province: next.practiceProvince || "",
        postalCode: next.practicePostalCode || "",
      };
      const locs = Array.isArray(prev.locations) ? [...prev.locations] : [];
      locs[0] = first;
      next.locations = locs;
      return next;
    });
    return;
  }

  if (name === "practiceMedicalType") {
    setPractice(prev => {
      const next = { ...prev, [name]: value, practiceType: value === "NM" ? "Non-Medical" : "Medical" };
      // sync locations[0]
      const first = {
        name: next.primaryLocationName || "Main Location",
        address1: next.practiceAddress || "",
        address2: next.practiceAddress2 || "",
        city: next.practiceCity || "",
        province: next.practiceProvince || "",
        postalCode: next.practicePostalCode || "",
      };
      const locs = Array.isArray(prev.locations) ? [...prev.locations] : [];
      locs[0] = first;
      next.locations = locs;
      return next;
    });
    return;
  }

  // default branch
  setPractice(prev => {
    const next = { ...prev, [name]: value };

    // Keep locations[0] synced for these fields + primary name
    const syncKeys = new Set([
      "primaryLocationName",
      "practiceAddress",
      "practiceAddress2",
      "practiceCity",
      "practiceProvince",
      "practicePostalCode",
    ]);

    if (syncKeys.has(name)) {
      const first = {
        name: (name === "primaryLocationName" ? value : next.primaryLocationName) || "Main Location",
        address1: next.practiceAddress || "",
        address2: next.practiceAddress2 || "",
        city: next.practiceCity || "",
        province: next.practiceProvince || "",
        postalCode: next.practicePostalCode || "",
      };
      const locs = Array.isArray(prev.locations) ? [...prev.locations] : [];
      locs[0] = first;
      next.locations = locs;
    }
    return next;
  });
}



  function handleClose() {
    setCloseAlert(true); // Show confirmation alert
  }

  const handleCancelNo = () => {
    setCloseAlert(false); // Hide alert and keep modal open
  };

  const handleCancelYes = async () => {
    setCloseAlert(false);
    navigate(0);
    props.onHide();
    // Close the modal after successful operation
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header
        closeButton={!closeAlert && !successAlert}
        className="border-secondary"
      >
        <Modal.Title
          id="contained-modal-title-vcenter"
          className="text-primary"
        >
          Edit Practice
        </Modal.Title>
      </Modal.Header>
      {closeAlert && (
        <Alert
          variant="info"
          className="w-100 d-flex align-items-center justify-content-between fs-6 fw-normal"
          onClose={() => setCloseAlert(false)}
        >
          <span>
            Are you sure you want to close? The entered data will be removed.
          </span>
          <div className="ms-auto d-flex">
            <Button
              variant="outline-primary"
              className="btn btn-outline-primary me-1"
              onClick={handleCancelYes}
            >
              <FaCheck />
            </Button>
            <Button
              variant="outline-secondary"
              className="btn btn-outline-secondary me-1"
              onClick={handleCancelNo}
            >
              <FaTimes />
            </Button>
          </div>
        </Alert>
      )}
      {successAlert && (
        <Alert
          variant="success"
          className="w-100 d-flex align-items-center justify-content-between fs-6 fw-normal"
          onClose={() => setCloseAlert(false)}
        >
          <span>The practice has been updated successfully</span>
        </Alert>
      )}
      <Modal.Body>
        <Form>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="practiceName">
              <Form.Label>Practice Name</Form.Label>
              <Form.Control
                placeholder=""
                name="practiceName"
                value={practice.practiceName}
                onChange={handleChange}
                isInvalid={!!errors.practiceName}
              />
              <Form.Control.Feedback type="invalid">
                {errors.practiceName}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md={4} controlId="checkboxGroup">
              <div className="d-flex flex-column">
                <Form.Check
                  disabled
                  type="checkbox"
                  label="Main Practice"
                  name="holdingPractice"
                  checked={practice.holdingPractice === "true"}
                  onChange={handleChange}
                  className="mb-2 mt-3"
                />
                <Form.Check
                  type="checkbox"
                  label="Non-Medical Practice"
                  name="practiceType"
                  checked={practice.practiceMedicalType === "NM"}
                  disabled
                />
              </div>
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} controlId="practiceNumber">
              <Form.Label>Practice Number</Form.Label>
              <Form.Control
                placeholder=""
                name="practiceNumber"
                value={practice.practiceNumber}
                onChange={handleChange}
                isInvalid={!!errors.practiceNumber}
              />
              <Form.Control.Feedback type="invalid">
                {errors.practiceNumber}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} controlId="vatNumber">
              <Form.Label>VAT Number</Form.Label>
              <Form.Control
                placeholder=""
                name="vatNumber"
                value={practice.vatNumber}
                onChange={handleChange}
                isInvalid={!!errors.vatNumber}
              />
              <Form.Control.Feedback type="invalid">
                {errors.vatNumber}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} className="mb-1">
              <Form.Label>Practice Type</Form.Label>
              <Form.Select
                name="practiceMedicalType"
                value={practice.practiceMedicalType}
                onChange={handleChange}
                isInvalid={!!errors.practiceMedicalType}
              >
                <option value="">Choose...</option>
                <option value="MP">Medical Practitioners GP</option>
                <option value="MP">Medical Practitioners Specialist</option>
                <option value="DP">Dental Practitioners</option>
                <option value="AP">Allied Practitioners</option>
                <option value="NM">Non-Medical</option>
              </Form.Select>

              <Form.Control.Feedback type="invalid">
                {errors.practiceMedicalType}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row>
            {availableDisciplines && availableDisciplines.length > 0 && (
              <>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label>Discipline</Form.Label>
                  <Form.Select
                    name="practiceDisciplineCode"
                    value={practice.practiceDisciplineCode || ""}
                    isInvalid={!!errors.practiceDisciplineCode}
                    onChange={(e) => {
                      const selectedCode = e.target.value;
                      const selected = availableDisciplines.find(
                        (d) => d.disciplineCode === selectedCode
                      );
                      handleChange({
                        target: {
                          name: "practiceDisciplineCode",
                          value: selected?.disciplineCode || "",
                        },
                      });
                      handleChange({
                        target: {
                          name: "practiceDisciplineName",
                          value: selected?.disciplineName || "",
                        },
                      });
                    }}
                  >
                    <option>Choose...</option>
                    {availableDisciplines.map((d, idx) => (
                      <option key={idx} value={d.disciplineCode}>
                        {d.disciplineName}
                      </option>
                    ))}
                  </Form.Select>

                  <Form.Control.Feedback type="invalid">
                    {errors.practiceDisciplineCode}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} controlId="practicehpcsa">
                  <Form.Label>Practice Owner HPCSA</Form.Label>
                  <Form.Control
                    className="mb-3"
                    placeholder=""
                    name="hpcsaNumber"
                    value={practice.hpcsaNumber || ""}
                    onChange={handleChange}
                    isInvalid={!!errors.hpcsaNumber}
                  />

                  <Form.Control.Feedback type="invalid">
                    {errors.hpcsaNumber}
                  </Form.Control.Feedback>
                </Form.Group>
              </>
            )}
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} controlId="practicePhoneNumber">
              <Form.Label>Practice Phone Number</Form.Label>
              <Form.Control
                placeholder="xxx-xxx-xxxx"
                name="practicePhoneNumber"
                value={practice.practicePhoneNumber}
                onChange={handleChange}
                isInvalid={!!errors.practicePhoneNumber}
              />
              <Form.Control.Feedback type="invalid">
                {errors.practicePhoneNumber}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} controlId="practiceEmail">
              <Form.Label>Practice Email</Form.Label>
              <Form.Control
                placeholder=""
                name="practiceEmail"
                value={practice.practiceEmail}
                onChange={handleChange}
                isInvalid={!!errors.practiceEmail}
              />
              <Form.Control.Feedback type="invalid">
                {errors.practiceEmail}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} controlId="practiceWebsite">
              <Form.Label>Practice Website</Form.Label>
              <Form.Control
                placeholder=""
                name="practiceWebsite"
                value={practice.practiceWebsite}
                onChange={handleChange}
                isInvalid={!!errors.practiceWebsite}
              />
              <Form.Control.Feedback type="invalid">
                {errors.practiceWebsite}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
  <Form.Group as={Col} controlId="primaryLocationName">
    <Form.Label>Primary Location Name</Form.Label>
    <Form.Control
      placeholder="e.g. Main Rooms"
      value={practice.primaryLocationName}
      onChange={handlePrimaryNameChange}
    />
  </Form.Group>
  <Form.Group as={Col} controlId="practicePlaceOfService">
    <Form.Label>Place of Service (Primary)</Form.Label>
    <Form.Select
      value={practice.practicePlaceOfService || ""}
      onChange={(e) =>
        setPractice((prev) => ({ ...prev, practicePlaceOfService: e.target.value }))
      }
    >
      <option value="">Select a place of service...</option>
      {placesOfService.map((pos) => (
        <option key={pos.HCFA_code} value={pos.HCFA_code}>
          {pos.HCFA_code} - {pos.newDescription}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Row>


          <Row className="mb-3">
            <Form.Group as={Col} controlId="practiceAddress">
              <Form.Label>Practice Address</Form.Label>
              <Form.Control
                placeholder=""
                name="practiceAddress"
                value={practice.practiceAddress}
                onChange={handleChange}
                isInvalid={!!errors.practiceAddress}
              />
              <Form.Control.Feedback type="invalid">
                {errors.practiceAddress}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} controlId="practiceAddress2">
              <Form.Label>Practice Address 2</Form.Label>
              <Form.Control
                placeholder=""
                name="practiceAddress2"
                value={practice.practiceAddress2}
                onChange={handleChange}
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} controlId="practiceCity">
              <Form.Label>City</Form.Label>
              <Form.Control
                name="practiceCity"
                value={practice.practiceCity}
                onChange={handleChange}
                isInvalid={!!errors.practiceCity}
              />
              <Form.Control.Feedback type="invalid">
                {errors.practiceCity}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} controlId="practiceProvince">
              <Form.Label>Province</Form.Label>
              <Form.Select
                value={practice.practiceProvince || ""}
                name="practiceProvince"
                onChange={handleChange}
              >
                <option>Choose...</option>
                <option>Eastern Cape</option>
                <option>Free State</option>
                <option>Gauteng</option>
                <option>KwaZulu-Natal</option>
                <option>Limpopo</option>
                <option>Mpumalanga</option>
                <option>North West</option>
                <option>Northern Cape</option>
                <option>Western Cape</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.practiceProvince}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} controlId="practicePostalCode">
              <Form.Label>Postal Code</Form.Label>
              <Form.Control
                name="practicePostalCode"
                value={practice.practicePostalCode}
                onChange={handleChange}
                isInvalid={!!errors.practicePostalCode}
              />
              <Form.Control.Feedback type="invalid">
                {errors.practicePostalCode}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <hr className="mt-2 mb-3" />
<Nav variant="tabs" activeKey={locTab} onSelect={setLocTab} className="mb-3">
  <Nav.Item>
    <Nav.Link eventKey="locations">Additional Locations</Nav.Link>
  </Nav.Item>
  <Nav.Item>
    <Nav.Link eventKey="numbering">Numbering</Nav.Link>
  </Nav.Item>
  <Nav.Item>
    <Nav.Link eventKey="eras">ERAs</Nav.Link>
  </Nav.Item>
</Nav>

{locTab === "locations" && <>
{/* PRIMARY (index 0): always read-only + grayed, sourced from practice address */}
<div className="border rounded p-2 mb-2 bg-light">
  <div className="d-flex justify-content-between align-items-start">
    <div>
      <div className="fw-semibold text-primary">
        <i className="fas fa-location-dot me-2" />
        {practice.primaryLocationName || "Main Location"}
      </div>
      <div className="text-muted small">(Primary: sourced from Practice Address above)</div>
    </div>
  </div>
  <div className="mt-2 small">
    <div>{practice.practiceAddress || "-"}</div>
    {practice.practiceAddress2 && <div>{practice.practiceAddress2}</div>}
    <div>
      {practice.practiceCity || "-"}
      {practice.practiceCity && practice.practiceProvince ? ", " : " "}
      {practice.practiceProvince || ""}
      {" "}
      {practice.practicePostalCode || ""}
    </div>
  </div>
</div>

{/* OTHER locations (index >= 1) */}
{(practice.locations || []).slice(1).map((loc, i) => {
  const idx = i + 1; // real index in locations
  const isEditing = editIndex === idx;

  if (!isEditing) {
    // READ-ONLY CARD
    return (
      <div key={`loc-${idx}`} className="border rounded p-2 mb-2">
        <div className="d-flex justify-content-between align-items-start">
          <div className="min-w-0">
            <div className="fw-semibold text-primary text-truncate" title={loc.name || "Location"}>
              <i className="fas fa-location-dot me-2" />
              {loc.name || "Location"}
            </div>
            <div className="small mt-1">
              <div>{loc.address1 || "-"}</div>
              {loc.address2 && <div>{loc.address2}</div>}
              <div>
                {loc.city || "-"}
                {loc.city && loc.province ? ", " : " "}
                {loc.province || ""} {loc.postalCode || ""}
              </div>
              {loc.placeOfService && (
                <div className="text-muted mt-1">
                  POS: {loc.placeOfService}
                  {(() => {
                    const match = placesOfService.find(
                      (pos) => pos.HCFA_code === loc.placeOfService
                    );
                    return match ? ` - ${match.newDescription}` : "";
                  })()}
                </div>
              )}
            </div>
          </div>

          <div className="ms-2 flex-shrink-0 d-flex gap-2">
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => { setEditIndex(idx); setDraftLoc({ ...loc }); }}
            >
              Edit
            </Button>
            <Button
              variant=""
              size="sm"
              onClick={() => removeLocation(idx)}
              aria-label="Remove location"
              title="Remove"
            >
              <i className="fa-solid fa-trash-can text-danger"></i>
            </Button>
          </div>
        </div>
      </div>
    );
  }

  // EDIT MODE CARD
  return (
    <div key={`loc-${idx}`} className="border rounded p-2 mb-2 bg-white">
      <Row className="g-2">
        <Form.Group as={Col} md={4}>
          <Form.Label>Name</Form.Label>
          <Form.Control
            value={draftLoc?.name || ""}
            onChange={(e) => setDraftLoc(d => ({ ...(d || {}), name: e.target.value }))}
          />
        </Form.Group>
        <Form.Group as={Col} md={8}>
          <Form.Label>Address 1</Form.Label>
          <Form.Control
            value={draftLoc?.address1 || ""}
            onChange={(e) => setDraftLoc(d => ({ ...(d || {}), address1: e.target.value }))}
          />
        </Form.Group>
      </Row>
      <Row className="g-2 mt-1">
        <Form.Group as={Col} md={6}>
          <Form.Label>Address 2</Form.Label>
          <Form.Control
            value={draftLoc?.address2 || ""}
            onChange={(e) => setDraftLoc(d => ({ ...(d || {}), address2: e.target.value }))}
          />
        </Form.Group>
        <Form.Group as={Col} md={6}>
          <Form.Label>City</Form.Label>
          <Form.Control
            value={draftLoc?.city || ""}
            onChange={(e) => setDraftLoc(d => ({ ...(d || {}), city: e.target.value }))}
          />
        </Form.Group>
      </Row>
      <Row className="g-2 mt-1">
        <Form.Group as={Col} md={6}>
          <Form.Label>Province</Form.Label>
          <Form.Select
            value={draftLoc?.province || ""}
            onChange={(e) => setDraftLoc(d => ({ ...(d || {}), province: e.target.value }))}
          >
            <option value="">Choose...</option>
            <option>Eastern Cape</option>
            <option>Free State</option>
            <option>Gauteng</option>
            <option>KwaZulu-Natal</option>
            <option>Limpopo</option>
            <option>Mpumalanga</option>
            <option>North West</option>
            <option>Northern Cape</option>
            <option>Western Cape</option>
          </Form.Select>
        </Form.Group>
        <Form.Group as={Col} md={6}>
          <Form.Label>Postal Code</Form.Label>
          <Form.Control
            value={draftLoc?.postalCode || ""}
            onChange={(e) => setDraftLoc(d => ({ ...(d || {}), postalCode: e.target.value }))}
          />
        </Form.Group>
      </Row>
      <Row className="g-2 mt-1">
        <Form.Group as={Col} md={12}>
          <Form.Label>Place of Service</Form.Label>
          <Form.Select
            value={draftLoc?.placeOfService || ""}
            onChange={(e) => setDraftLoc(d => ({ ...(d || {}), placeOfService: e.target.value }))}
          >
            <option value="">Select a place of service...</option>
            {placesOfService.map((pos) => (
              <option key={pos.HCFA_code} value={pos.HCFA_code}>
                {pos.HCFA_code} - {pos.newDescription}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Row>

      <div className="d-flex justify-content-end gap-2 mt-2">
        <Button variant="outline-secondary" size="sm" onClick={() => { setEditIndex(null); setDraftLoc(null); }}>
          Cancel
        </Button>
        <Button
          variant="primary"
          size="sm"
          onClick={() => {
            // simple guard
            if (!draftLoc?.name || !draftLoc?.address1 || !draftLoc?.city || !draftLoc?.province || !draftLoc?.postalCode) {
              alert("Please fill name, address, city, province and postal code.");
              return;
            }
            setPractice(prev => {
              const next = { ...prev, locations: [...(prev.locations || [])] };
              next.locations[idx] = { ...draftLoc };
              return next;
            });
            setEditIndex(null);
            setDraftLoc(null);
          }}
        >
          Save
        </Button>
      </div>
    </div>
  );
})}

{/* ADD NEW */}
{editIndex === "new" ? (
  <div className="border rounded p-2 mb-2 bg-white">
    <Row className="g-2">
      <Form.Group as={Col} md={4}>
        <Form.Label>Name</Form.Label>
        <Form.Control
          value={draftLoc?.name || ""}
          onChange={(e) => setDraftLoc(d => ({ ...(d || {}), name: e.target.value }))}
          placeholder="e.g. Branch - Sandton"
        />
      </Form.Group>
      <Form.Group as={Col} md={8}>
        <Form.Label>Address 1</Form.Label>
        <Form.Control
          value={draftLoc?.address1 || ""}
          onChange={(e) => setDraftLoc(d => ({ ...(d || {}), address1: e.target.value }))}
        />
      </Form.Group>
    </Row>
    <Row className="g-2 mt-1">
      <Form.Group as={Col} md={6}>
        <Form.Label>Address 2</Form.Label>
        <Form.Control
          value={draftLoc?.address2 || ""}
          onChange={(e) => setDraftLoc(d => ({ ...(d || {}), address2: e.target.value }))}
        />
      </Form.Group>
      <Form.Group as={Col} md={6}>
        <Form.Label>City</Form.Label>
        <Form.Control
          value={draftLoc?.city || ""}
          onChange={(e) => setDraftLoc(d => ({ ...(d || {}), city: e.target.value }))}
        />
      </Form.Group>
    </Row>
    <Row className="g-2 mt-1">
      <Form.Group as={Col} md={6}>
        <Form.Label>Province</Form.Label>
        <Form.Select
          value={draftLoc?.province || ""}
          onChange={(e) => setDraftLoc(d => ({ ...(d || {}), province: e.target.value }))}
        >
          <option value="">Choose...</option>
          <option>Eastern Cape</option>
          <option>Free State</option>
          <option>Gauteng</option>
          <option>KwaZulu-Natal</option>
          <option>Limpopo</option>
          <option>Mpumalanga</option>
          <option>North West</option>
          <option>Northern Cape</option>
          <option>Western Cape</option>
        </Form.Select>
      </Form.Group>
      <Form.Group as={Col} md={6}>
        <Form.Label>Postal Code</Form.Label>
        <Form.Control
          value={draftLoc?.postalCode || ""}
          onChange={(e) => setDraftLoc(d => ({ ...(d || {}), postalCode: e.target.value }))}
        />
      </Form.Group>
    </Row>
    <Row className="g-2 mt-1">
      <Form.Group as={Col} md={12}>
        <Form.Label>Place of Service</Form.Label>
        <Form.Select
          value={draftLoc?.placeOfService || ""}
          onChange={(e) => setDraftLoc(d => ({ ...(d || {}), placeOfService: e.target.value }))}
        >
          <option value="">Select a place of service...</option>
          {placesOfService.map((pos) => (
            <option key={pos.HCFA_code} value={pos.HCFA_code}>
              {pos.HCFA_code} - {pos.newDescription}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </Row>

    <div className="d-flex justify-content-end gap-2 mt-2">
      <Button variant="outline-secondary" size="sm" onClick={() => { setEditIndex(null); setDraftLoc(null); }}>
        Cancel
      </Button>
      <Button
        variant="primary"
        size="sm"
        onClick={() => {
          if (!draftLoc?.name || !draftLoc?.address1 || !draftLoc?.city || !draftLoc?.province || !draftLoc?.postalCode) {
            alert("Please fill name, address, city, province and postal code.");
            return;
          }
          setPractice(prev => ({ ...prev, locations: [...(prev.locations || []), { ...draftLoc }] }));
          setEditIndex(null);
          setDraftLoc(null);
        }}
      >
        Save
      </Button>
    </div>
  </div>
) : (
  <div className="mt-2 mb-3">
    <Button
      variant="outline-primary"
      size="sm"
      onClick={() => { setEditIndex("new"); setDraftLoc({ name: "", address1: "", address2: "", city: "", province: "", postalCode: "", placeOfService: "" }); }}
    >
      + Add Location
    </Button>
  </div>
)}



</>}

{locTab === "numbering" && (
  <div className="mb-3">
    <p className="text-muted small mb-3">
      Choose how account and patient numbers are generated for this practice.
    </p>
    {[
      { value: "custom", label: "Custom (manual entry)", desc: "You enter the number manually for each patient." },
      { value: "sequential", label: "Sequential (ACC/PAT)", desc: "Numbers auto-increment: ACC00001, PAT00001, etc." },
      { value: "surname", label: "Surname-based", desc: "Numbers use the patient's surname code, e.g. DLA0001 or PHYDLA0001 with a prefix." },
    ].map(({ value, label, desc }) => (
      <Form.Check
        key={value}
        type="radio"
        id={`edit-method-${value}`}
        label={<><strong>{label}</strong><br /><span className="text-muted small">{desc}</span></>}
        value={value}
        checked={numberingMethod === value}
        onChange={() => setNumberingMethod(value)}
        className="mb-2"
      />
    ))}
    {numberingMethod === "surname" && (
      <Form.Group className="mt-3" style={{ maxWidth: 220 }}>
        <Form.Label>Prefix <span className="text-muted small fw-normal">(optional)</span></Form.Label>
        <Form.Control
          placeholder="e.g. PHY"
          value={numberingPrefix}
          maxLength={6}
          onChange={(e) => setNumberingPrefix(e.target.value.toUpperCase().replace(/[^A-Z]/g, ""))}
        />
        <Form.Text className="text-muted">
          Leave empty to use surname code only (e.g. DLA0001).
        </Form.Text>
      </Form.Group>
    )}
  </div>
)}

{locTab === "eras" && (
  <div className="mb-3">
    <p className="text-muted small mb-3">
      Choose how incoming ERAs (electronic remittance advices) are processed
      for this practice.
    </p>
    <Form.Check
      type="switch"
      id="edit-era-enabled"
      className="mb-3"
      label={
        <>
          <strong>Practice receives ERAs</strong>
          <br />
          <span className="text-muted small">
            Turn off for a practice that does not subscribe to electronic
            remittance advices. The ERA matcher and unmatched-ERA indicators
            are hidden on its accounts.
          </span>
        </>
      }
      checked={eraEnabled}
      onChange={(e) => setEraEnabled(e.target.checked)}
    />
    <Form.Check
      type="switch"
      id="edit-era-auto-allocate"
      disabled={!eraEnabled}
      label={
        <>
          <strong>Automatically allocate ERAs</strong>
          <br />
          <span className="text-muted small">
            Incoming ERAs are matched to submitted claims and receipts are
            created automatically. Claims that cannot be matched appear on the
            account as unmatched.
          </span>
        </>
      }
      checked={eraAutoAllocate}
      onChange={(e) => setEraAutoAllocate(e.target.checked)}
    />
    {!eraAutoAllocate && (
      <div className="text-muted small mt-2">
        ERAs will only be recorded and listed under the ERA section: no
        matching, receipts or invoice updates happen. Payments are captured
        manually. ERAs received while auto-allocation was on keep their
        matched/unmatched results.
      </div>
    )}
  </div>
)}

          <div className="d-flex justify-content-center align-items-center">
            <Button
              variant="primary"
              className="px-5 py-2"
              onClick={handleSubmit}
              type="submit"
            >
              Submit
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
